// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { productTooltipStyles } from "@pace/App/Components/Product/ProductTooltip";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color } from "@pace/XDL/Utilities";
import { css } from "styled-components";

productTooltipStyles.wrapper = {
    css: css`
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: end;
        span[role="tooltip"] {
            margin: 0;
        }

        .info-trigger-container {
            margin-right: 4px;
        }

        ${IconWrapper} {
            color: ${color("secondary", 0.44)};
            width: 12px;
            height: 12px;
        }

        &:hover,
        &:focus {
            ${IconWrapper} {
                color: ${color("secondary")};
            }
        }
    `,
};

productTooltipStyles.trigger = {
    css: css`
        display: flex;
        align-items: center;
        cursor: pointer;

        &:disabled {
            ${TypographyStyle} {
                opacity: 0.44;
            }

            & + .tooltip-container ${IconWrapper} {
                color: ${color("common.ui14")};
                opacity: 0.5;
            }
        }
    `,
};

productTooltipStyles.label = {
    color: "common.ui14",
    size: 10,
    weight: fontConfig.weight.bold,
    lineHeight: "11px",
};

productTooltipStyles.value = {
    color: "common.ui14",
    size: 10,
    weight: fontConfig.weight.bold,
    lineHeight: "11px",
};